import ErrorUtils from 'utils/error-utils';
import SegmentUtils from 'utils/segment';
import getUserLocation from '../utils/user-location';
export default function trackExpressEligibilityDetermined({ isAdmin, isEligible, isEventPackage, spotIsOn, isMonthly, isRebooking, selectedRatePresent = true, badOptimizelyLoad = false, badConfig = false, }) {
    try {
        const properties = {
            admin_user: isAdmin,
            is_eligible: isEligible,
            is_event_package: isEventPackage,
            spot_is_on: spotIsOn,
            is_monthly: isMonthly,
            is_rebooking: isRebooking,
            selected_rate_present: selectedRatePresent,
            bad_optimizely_load: badOptimizelyLoad,
            bad_config: badConfig,
            ...getUserLocation(),
        };
        SegmentUtils.track({
            event: 'Express Eligibility Determined',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - Express Eligibility Determined',
        });
    }
}
